import { AbandonedCartRequest } from '../../hooks/abandoned-cart'

export const MAX_PERIOD_DAYS = 93
export const DEFAULT_PERIOD_DAYS = 90

const DAY_MS = 24 * 60 * 60 * 1000
const DATE = /^\d{4}-\d{2}-\d{2}$/

const pad = (value: number): string => String(value).padStart(2, '0')

export const toInputDate = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

export const defaultPeriod = (today: Date = new Date()): AbandonedCartRequest => {
  const from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (DEFAULT_PERIOD_DAYS - 1))
  return { from: toInputDate(from), to: toInputDate(today) }
}

const daysOf = (value: string): number => {
  const [year, month, day] = value.split('-').map(Number)
  return Date.UTC(year, month - 1, day) / DAY_MS
}

export const periodError = (period: AbandonedCartRequest): string | null => {
  if (!DATE.test(period.from) || !DATE.test(period.to)) return 'Informe as duas datas.'
  const span = daysOf(period.to) - daysOf(period.from) + 1
  if (span < 1) return 'A data inicial deve ser anterior à final.'
  if (span > MAX_PERIOD_DAYS) return `Escolha um período de até ${MAX_PERIOD_DAYS} dias.`
  return null
}
